<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div>
    <div class="scrollable-mode">
      <el-switch
        v-if="!allValueZero"
        v-model="scrollableMode"
        :disabled="lineChartData.xAxisData.length == 1"
        @change="handleScrollableMode"
        active-text="scroll chart">
      </el-switch>
    </div>
    <div class="view-by">View by {{this.type}}</div>
    <div ref="chart" class="wy-panel-line-chart" :id="chartId"></div>
    <div ref="hoverChart" id='hoverinfo-line'>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import moment from 'moment';
import WyChartModule from '../../../library/wy-chart-module.js';
import WyChartUtils from '../utils/wy-chart-util.js';
export default Vue.extend({
  name: 'wy-panel-line-chart',
  props: ['chartId', 'lineChartData', 'type'],

  data() {
    return {
      module: this,
      loading: false,
      scrollableMode: false,
      allValueZero: true,
      tickformat: '',
      lineColor: '#1C4DB2',
      localData: null,
      localMedian: null,
      hasRegressionData: true
    }
  },
  computed: {
    ...mapGetters(['dataModel', 'legendColors']),
  },
  methods: {
    handleDateChange(type){
      if(type == 'year'){
        this.tickformat = '%Y'
      } else if (type == 'quarter'){
        this.tickformat = '%b %d %Y'
      } else if (type == 'week'){
        this.tickformat = '%b %d %Y'
      } else if (type == 'day'){
        this.tickformat = '%b %d %Y'
      } else if (type == 'month'){
        this.tickformat = '%b %Y'
      }
    },
    buildTooltip(point, data) {

      const pointX = point.bbox.x1;  
      const pointY = point.bbox.y1;
      const pointIndex = point.pointIndex;

      let localData = JSON.parse(JSON.stringify(data));
      function reverseArr(input) {
        var ret = new Array;
        for(var i = input.length-1; i >= 0; i--) {
            ret.push(input[i]);
        }
        return ret;
      }
      reverseArr(localData);
      
      let colors = [];
      localData.forEach(el => {
        if(el.line){
          colors.push(el.line.color)
        }
      });
      let values = [];
      localData.forEach(el => {
        values.push(el.y[pointIndex]);
      });

      let labels = [];
      this.lineChartData.legends.forEach(el => labels.push(el));

      if(values.length > 1){
        labels.push('regression')
      }
      let sum = 0;

      let valuesWithoutRegresssion = values.slice(1);
      valuesWithoutRegresssion.forEach(num => sum += num);

      let pointDate = "";
      if(data[0].z && data[0].z.length > 0) {
        pointDate = data[0].z[pointIndex];
      }
      else {
        if(this.type == 'day') {
          pointDate = moment(data[0].x[pointIndex]).format("MMM DD YYYY");
        }
        else {
          pointDate = data[0].x[pointIndex];
        }
      }


      const labelHtml = labels.map((p, idx) => {
        
      return `<div style="display:flex;">
                  <div class="${p == 'regression'? 'regression-marker':'dx-tooltip-pipe'}" style="background-color: ${colors[idx]}">
                  </div>
                  <div class="dx-tooltip-label" style="font-weight: 400; display: flex; flex-direction: column">
                      <div class="tooltip-legendtext-label">${p}</div>
                      <div class="tooltip-legendtext-num">${labels.includes('cost savings')? "$" +  Math.round(values[idx]).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : values[idx] == 0? '0%': values[idx] !== null? values[idx].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + '%': '0%'}</div>
                  </div>
                </div>`;
      }).join('');

      const html = ` <div class="dx-tooltip tooltip-bg" style="left: ${pointX + 10}px; top:${pointY - 110}px">
                        <div style="pointer-events: none;">
                            <div class="tooltip-legendtitletext" style="text-align:center">${pointDate}</div>
                        </div>
                        <div>
                            ${labelHtml}
                        </div>
                    </div>`;
      return html;
    },

    toggleLegend(toggleLengend, flag) {
      this.hasRegressionData = flag;
      if(flag) {
        const wyChart = new WyChartModule();
        this.localData = JSON.parse(JSON.stringify(this.lineChartData.yAxisData));
        this.localMedian = wyChart.prepareRegressionDataByTrace({x: this.lineChartData.xAxisData, y: this.lineChartData.yAxisData}, {});
      }
      else {
        this.lineChartData.legends.forEach(legend => {
          if(legend == toggleLengend && toggleLengend != 'regression') {
            this.lineChartData.yAxisData.forEach((value, index) => {
              this.localData[index] = null
            })
          }
          else {
            if(toggleLengend == 'regression') {
              this.localMedian.regressionData.yValues.forEach((value, index) => {
                this.localMedian.regressionData.yValues[index] = null
              })
            }
          }
        })
      }
      this.buildChart('legend');
    },

    handleScrollableMode() {
      this.buildChart('scrollable')
    },

    buildChart(mode) {
      setTimeout(()=>{
        let colors = [];
        this.lineChartData.xAxisData.forEach(() => {
          colors.push('transparent');
        });

        const wyChart = new WyChartModule();
        if(!mode) {
          this.hasRegressionData = true;
        }
        this.allValueZero = true;
        this.lineChartData.yAxisData.forEach(yVal => {
          if(yVal != 0) {
            this.allValueZero = false;
          }
        })
        this.localMedian = wyChart.prepareRegressionDataByTrace({x: this.lineChartData.xAxisData, y: this.lineChartData.yAxisData}, {});
        this.lineColor = this.lineChartData.legendColors[0];
        var traceData = {
          x: this.lineChartData.xAxisData,
          y: this.lineChartData.yAxisData,
          name:'',
          type: 'scatter',
          mode: "lines+markers",
          cliponaxis: false,
          marker: {color: colors, size: 8},
          showlegend: false,
          fill: 'none',
          line: {
            color: this.lineColor,//'#6567CA',
            width: 1.5
          },    
          //hovertemplate: " "    
        };
        
        // let selectorOptions = {
        // buttons: [
            // {
            //     name: '1m',
            //     count: 1,
            //     label: '1m',
            //     step: 'month',
            //     stepmode: 'backward'
            // },
            // {
            //     name: '6m',
            //     count: 6,
            //     label: '6m',
            //     step: 'month',
            //     stepmode: 'todate'
            // },
            // {   
            //     step: 'all'
            // }
        //   ]
        // }
        let traceRegression = {
          name: '',
          type: 'scatter',
          mode: "lines",
          key: 'regression',
          x: this.localMedian.regressionData.xValues,
          y: this.localMedian.regressionData.yValues,
          showlegend: false,
          fill: 'none',
          line: {
            dash: 'dot',
            color: '#0A0B37',
            width: 1.5
          },          
        };

        let layout = {
          margin: { l: 60, r: 80, t: 25 , b: 20, pad: 10},
          autosize: true,
          // title: {
          //   text: this.type,
          //   font: {
          //     size: 12
          //   },
          //   y:  0.99,
          //   x: 0.94
          // },
          height: 300,
          dragmode: false,
          // showlegend: true,
          hovermode: 'x',
          legend: {
            orientation: 'h',
            x: 0.41,
            y: -0.5
          },
          xaxis:  {
            autorange: true,
            fixedrange: true,
            showgrid: false,
            zeroline: false,
            automargin: true,
            showline: true,
            tickcolor: 'transparent',
            rangeslider: {autorange: true},
            side: 'bottom'
          },
          yaxis: {
            type: 'linear',
            autorange: true,
            rangemode: 'nonnegative',
            separatethousands: true,
            showgrid: true,
            zeroline: false,
            side: 'right',
            showline: true,
            linecolor: '#edeff0',
            fixedrange: true,
          }
        }
        if(this.type) {
          this.handleDateChange(this.type)
        }
        
        let data = [traceData];
        let config = {responsive: true, displayModeBar: false, scrollZoom: false, showTips: false};
        if(this.lineChartData.suffix == '%') {
          layout.yaxis.range = [0, 100];
          layout.yaxis.ticksuffix = '%';
        }
        if(this.lineChartData.xAxisData.length > 1 && this.lineChartData.xAxisData.length < 5) {
          layout.xaxis.nticks = this.lineChartData.xAxisData.length;
          layout.xaxis.tickformat = this.tickformat;
          if(this.type == 'year') {
            layout.xaxis.tickformat = null;
          }
        }
        if(this.lineChartData.xAxisData.length == 1) {
          layout.xaxis.nticks = 3;
          // layout.xaxis.tickformat = '%b %d %Y'
          traceData.marker.color = '#214586';
        } 
        if(this.lineChartData.xAxisData.length < 5) {
          layout.xaxis.nticks = this.lineChartData.xAxisData.length;
          // layout.xaxis.tickformat = '%b %d %Y'
        }
        if(this.lineChartData.xAxisData.length >= 5) {
        // if(this.lineChartData.xAxisData.length >= 5 && this.lineChartData.xAxisData.length < 10) {
        //   layout.xaxis.nticks = 5;
        //   layout.xaxis.tickformat = this.tickformat;
        // }
        // if(this.lineChartData.xAxisData.length >= 10) {
          if(!this.scrollableMode) {
            layout.xaxis.tickmode = 'array';
            layout.xaxis.tickvals = [this.lineChartData.xAxisData[0], this.lineChartData.xAxisData[Math.round((this.lineChartData.xAxisData.length - 1)/2)], this.lineChartData.xAxisData[this.lineChartData.xAxisData.length-1]]
          }
          layout.xaxis.nticks = 3;
          layout.xaxis.tickformat = this.tickformat;
        }

        let xLength = this.lineChartData.xAxisData.length
        if(!mode) {
          if(xLength < 20 || this.allValueZero) {
            this.scrollableMode = false;
          }
          else {
            this.scrollableMode = true;
          }
        }
        if(this.type == 'day') {
          WyChartUtils.scrollableChartSetLayoutByDay(this.lineChartData.xAxisData, xLength, layout)
        }
        if(this.type == 'week') {
          WyChartUtils.scrollableChartSetLayoutByWeek(xLength, layout)
        }
        if(this.type == 'month') {
          WyChartUtils.scrollableChartSetLayoutByMonth(xLength, layout)
        }
        if(this.type == 'year') {
          WyChartUtils.scrollableChartSetLayoutByYear(xLength, layout)
        }
        if(!this.scrollableMode) {
          layout.xaxis.autorange = true;
          layout.xaxis.rangeslider = null; 
        }
        else {
          layout.xaxis.autorange = false;
          layout.xaxis.rangeslider = {autorange: true, thickness: 0.1}
        }
        if(this.hasRegressionData) {
          data.push(traceRegression)
        }
        if(!mode || mode != 'legend') {
          // eslint-disable-next-line no-undef
          Plotly.newPlot(this.chartId, data, layout, config);
        }
        else {
          // eslint-disable-next-line no-undef
          Plotly.newPlot(this.chartId, data, this.$refs.chart.layout, this.$refs.chart.config);
        }
        this.$refs.chart.on('plotly_hover', (hoverData) => {          
          hoverData.event.preventDefault();
          hoverData.event.stopPropagation();
          try {
            if(this.$refs.hoverChart) {    
              const toolTipHtml = this.buildTooltip(hoverData.points[0], this.$refs.chart.data);
              const gd = this.$refs.hoverChart;
              gd.style.display = "block";
              gd.innerHTML = toolTipHtml;
              
              let pn = hoverData.points[0].pointNumber;
              colors[pn] = this.lineColor;
              let update = {'marker': {color: colors}};
              // eslint-disable-next-line no-undef
              Plotly.relayout(this.$refs.chart, update, 0);
            }
          }
          catch(error) {
            console.error(error)
          }
        });

        // mouse out on point
        this.$refs.chart.on('plotly_unhover', (hoverData) => {
          try {
            if(this.$refs.hoverChart) {    
              let pn = hoverData.points[0].pointNumber;
              colors[pn] = "transparent";
              let update = {'marker': {color: colors}};
              // eslint-disable-next-line no-undef
              Plotly.relayout(this.$refs.chart, update, 0);

              const gd = this.$refs.hoverChart;
              gd.innerHTML = '';
              gd.style.display = "none";
            }
          }
          catch(error) {
            console.error(error)
          }
        });
      }, 50)
    }
  },

  mounted(){
    this.buildChart();

    this.$root.$on(`fire-selected-date-change-events`, (type) => {
        this.handleDateChange(type)
      }
    )
  }
});
</script>

<style lang="scss">
    .tooltip-bg{
      box-shadow: 2px 1px 10px 1px rgba(199,199,199,0.76);
      border: none !important;
      width: fit-content !important;
      padding: 20px !important;
    }
    .tooltip-bg::before {
      content:"";
    }

    .tooltip-legendtext-label{
      font-weight: 400 !important;
      color: #4B5158 !important;
      margin-bottom: 5px;
      font-size: 14.22px !important;
    }
    .tooltip-legendtext-num{
      font-weight: 500 !important;
      font-size: 14.22px !important;
      margin-bottom: 10px;
      color: var(--site-font-secondary-color) !important;    
    }

    .tooltip-legendtitletext{
      //float: left;
      margin-bottom: 10px;
      font-size: 14.22px !important;
      font-weight: 400 !important;
      color: #828E9A !important;
    }
    .dx-tooltip {
      position: absolute;
      color: rgb(0, 0, 0);
      padding: 10px;
      background: rgb(255, 255, 255);
      border-radius: 3px;
      z-index: 10000;
      flex-direction: column;
      pointer-events: none;
    }

    .dx-tooltip-pipe {
      align-self: center;
      margin-right: 5px;
      width: 20px;
      margin-bottom: 30px;
      height: 20px;
      border-radius: 2px;
      background-color: var(--site-font-chart-color);
      clip-path: circle(30%);
    }
    .regression-marker{
      align-self: center;
      margin-right: 5px;
      width: 15px;
      height: 3px;
      border-radius: 2px;
      margin-bottom: 30px;
      background-color: unset !important;
      background: repeating-linear-gradient(to right, black 0, black 5px, transparent 5px, transparent 7px);
    }

    .dx-tooltip-label {
      display: flex;
      width: 100%;
      justify-content: space-between;
    }
  .wy-panel-line-chart {
    position: relative;
    // right: 20px;
    // width: 450px;
    // bottom: 40px;
    .plotly .cursor-crosshair {
      cursor: pointer;
    }
    .legendtext {
      font-size: 0.55vw !important;
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
    }
    .hoverlayer{
      display: none;
    }

    g.yaxislayer-above .ytick text {
      font-size: 0.55vw !important;
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
    }
    g.xaxislayer-above .xtick text{
      font-size: 0.5vw !important;
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
    }
    .legendtext {
      width: 200px;
      font-size: 0.55vw !important;
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
    }

    g.zerolinelayer {
      path.yzl.zl.crisp {
        stroke: rgb(238, 238, 238) !important;
      }
    }
    rect.rangeslider-slidebox {
      cursor: grab !important;
    }
    // .xtick {
    //   text {
    //     font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
    //   }
    // }
    .cursor-ew-resize, .cursor-w-resize, .cursor-e-resize {
      cursor: default !important;
    }
    rect.rangeslider-mask-min, rect.rangeslider-mask-max {
      fill: #888888 !important;
      fill-opacity: 0.5 !important;
    }
  }
  .wy-panel-line-chart.js-plotly-plot .plotly .cursor-ns-resize {
    cursor: pointer !important;
    // cursor: move !important;
  }
  .dragcover {
    cursor: grab !important;
  }
  
  @media screen and (max-width: 1400px) {
    .wy-panel-line-chart {
      g.yaxislayer-above .ytick text {
        font-size: 0.85vw !important;
      }
      g.xaxislayer-above .xtick text{
        font-size: 0.85vw !important;
      }
      .legendtext {
        font-size: 0.85vw !important;
      }
    }
  }
  
</style>